import { MissionRobotTypeOption } from 'api/RobotApi'
import { Button } from 'components/Button/Button'
import Dropdown, { IOption } from 'components/Dropdown/Dropdown'
import Title from 'components/Title/Title'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Modal from 'react-modal'

import style from './AddMissionModal.module.css'

interface IDialogProps {
  isOpen: boolean
  robotTypeOptions: MissionRobotTypeOption[]
  onClose: () => void
  onSelect: (robotType: string) => void
}

const AddMissionModal = ({
  isOpen,
  robotTypeOptions: options,
  onClose,
  onSelect,
}: React.PropsWithChildren<IDialogProps>) => {
  const { t } = useTranslation()

  const onCancelClicked = () => {
    onClose()
  }

  const onSelectClicked = async () => {
    onSelect(robotType)
  }

  const dropdownOptions: IOption[] = options
    .filter(opt => opt.display_name?.trim())
    .map(opt => ({
      text: opt.display_name,
      value: opt.robot_type,
    }))

  const [robotType, setRobotType] = useState((dropdownOptions[0]?.value as string) || '')

  const [robotTypeOption, setRobotTypeOption] = useState<IOption>(dropdownOptions[0] || { text: '', value: '' })

  // Sync state when options prop changes (component is always mounted, so useState keeps stale initial value)
  useEffect(() => {
    if (dropdownOptions.length > 0) {
      setRobotType(dropdownOptions[0].value as string)
      setRobotTypeOption(dropdownOptions[0])
    }
  }, [options])

  const onTypeSelected = (e: IOption) => {
    setRobotTypeOption(e)
    setRobotType((e.value as string) || '')
  }

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onCancelClicked}
      className={style.root}
      style={{
        overlay: {
          zIndex: 100,
          backgroundColor: 'rgba(27, 43, 72, 0.6)',
        },
      }}
      ariaHideApp={false}
    >
      <div className={style.modal}>
        <div className={style.head}>
          <Title text="Select a robot's type" className={style.title} />
        </div>
        <div className={style.row}>
          <Dropdown
            className={style.textfield}
            currentOption={robotTypeOption}
            options={dropdownOptions}
            onClickOption={onTypeSelected}
          />
        </div>
        <div className={style.footer}>
          <Button.Outlined className={style.btn} onClick={onCancelClicked}>
            {t('mission_settings.label_cancel')}
          </Button.Outlined>
          <Button.Standart className={style.btn} onClick={onSelectClicked}>
            Select
          </Button.Standart>
        </div>
      </div>
    </Modal>
  )
}

export default AddMissionModal
